<template>
  <div class="Guard3InspectorForm" v-if="reserveInfo">
    <!-- if edit -->
    <el-form :model="guard3Form" ref="guard3Form" v-if="!isView" :disabled="!editable">
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value" v-if="editable">{{ getUserProfile().userName }}</div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.carring") }}</div>
          <div class="value">
            {{ (reserveInfo.carringData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.entourage") }}</div>
          <div class="value">
            {{
              (reserveInfo.entourageData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist")
            }}
          </div>
        </div>
        <article v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType) === false">
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.releaseStuff") }}</div>
            <div class="value">
              {{ hasAddNewRelease.resValue == "Y" ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
            </div>
          </div>
          <div class="card-item addForm" v-if="viewAddReleaseList != null && viewAddReleaseList.length > 0">
            <div class="el-form-item" v-for="(item, index) in viewAddReleaseList" :key="index">
              <div class="label">{{ $t("pages.wording.releaseNo") + " " + (index + 1) }}</div>
              <div class="value">{{ item.resValue }}</div>
            </div>
          </div>
        </article>
        <article v-else>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.releaseListTitle") }}</div>
            <div class="value">
              <span class="pdf-button" @click="releaseListClick">
                <span><i class="el-icon-document"></i>{{ $t("pages.wording.releaseList") }}</span>
              </span>
            </div>
          </div>
        </article>
        <div class="card-item">
          <el-form-item :label="$t('pages.wording.failReason')">
            <el-select v-model="guard3Form.failReason.resValue" :placeholder="$t('pages.wording.placeholderSelect')">
              <el-option
                v-for="item in $store.getters.sortDDL(guard3Form.failReason.option)"
                :key="item.code"
                :label="item[$i18n.locale]"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="card-item">
          <el-form-item :label="$t('pages.wording.remark')">
            <el-input v-model="guard3Form.remark" :placeholder="$t('pages.wording.placeholderInput')"></el-input>
          </el-form-item>
        </div>
      </CardTable>
    </el-form>
    <!-- if view -->
    <el-form :model="guard3Form" ref="guard3Form" v-else>
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value">
            {{
              reserveInfo.inspectData.in2InspectRecord === null
                ? ""
                : reserveInfo.inspectData.in2InspectRecord.inspectOperator
            }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.checkTime") }}</div>
          <div class="value">
            {{ viewInspectDateTime }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.carring") }}</div>
          <div class="value">
            {{ (reserveInfo.carringData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.entourage") }}</div>
          <div class="value">
            {{
              (reserveInfo.entourageData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist")
            }}
          </div>
        </div>
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType) === false">
          <div class="label">{{ $t("pages.wording.releaseStuff") }}</div>
          <div class="value">
            {{ hasAddNewRelease.resValue == "Y" ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item addForm" v-if="viewAddReleaseList != null && viewAddReleaseList.length > 0">
          <div class="el-form-item" v-for="(item, index) in viewAddReleaseList" :key="index">
            <div class="label">{{ $t("pages.wording.releaseNo") + " " + (index + 1) }}</div>
            <div class="value">{{ item.resValue }}</div>
          </div>
        </div>
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType)">
          <div class="label">{{ $t("pages.wording.releaseListTitle") }}</div>
          <div class="value">
            <span class="pdf-button" @click="releaseListClick">
              <span><i class="el-icon-document"></i>{{ $t("pages.wording.releaseList") }}</span>
            </span>
          </div>
        </div>
        <div class="card-item" v-if="reserveInfo.inspectData?.in2InspectRecord?.inspectStatus === 'FAIL'">
          <div class="label">{{ $t("pages.wording.failReason") }}</div>
          <div class="value">{{ viewFailReason }}</div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.remark") }}</div>
          <div class="value">
            {{ reserveInfo.inspectData?.in2InspectRecord?.inspectRemark ?? "" }}
          </div>
        </div>
      </CardTable>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { utils } from "@/utils/utils.js"
import CardTable from "@/components/common/CardTable.vue"

export default {
  name: "Guard3InspectorForm",
  components: {
    CardTable,
  },
  props: {
    editable: {
      type: Boolean,
    },
    isView: {
      type: Boolean,
    },
    reserveInfo: {
      type: Object,
    },
    inspectDetail: {
      type: Object,
    },
  },
  data() {
    return {
      guard3Form: {
        failReason: {
          // item: "s3-5",
          option: [],
          resValue: null,
          description: "UnqualifiedReason",
          result: true,
        },
        remark: null,
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile"]),
    init() {
      this.getFailReasonBase()
    },
    isReserveForERPRelease(reserveType) {
      return this.$global.erpReserveType.includes(reserveType)
    },
    getInspectData() {
      return {
        success: true,
        formData: {
          remark: this.guard3Form.remark,
          inspectItem: [],
          failReason: this.guard3Form.failReason.resValue,
        },
      }
    },
    releaseListClick() {
      this.$emit("releaseListClick")
    },
    async getFailReasonBase() {
      this.guard3Form.failReason.option = await utils.getCodeListWithCulture(
        this.reserveInfo.reserveData.reserveRegion,
        this.reserveInfo.reserveData.reserveArea,
        "leaveNotPassReason"
      )
    },
  },
  computed: {
    viewFailReason() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in2CheckItems == null) {
        return ""
      }
      let item = this.reserveInfo.inspectData.in2CheckItems.find((c) => c.description === "UnqualifiedReason")
      return this.$store.getters.getSysCodeText("leaveNotPassReason", item.resValue)
    },
    hasAddNewRelease() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return ""
      }
      let item = this.reserveInfo.inspectData.in1CheckItems.find((c) => c.description === "ReleaseStuff")
      return item
    },
    viewAddReleaseList() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return null
      }
      let item = this.reserveInfo.inspectData.in1CheckItems.filter((c) => c.description === "ReleaseNo")
      return item
    },
    viewInspectDateTime() {
      return this.reserveInfo.inspectData.in2InspectRecord === null
        ? ""
        : utils.parseISOStringToDateTime(this.reserveInfo.inspectData.in2InspectRecord.inspectDatetime)
    },
  },
}
</script>

<style scoped>
.card-item.addForm {
  display: block;
}

.card-item.addForm ::v-deep .el-form-item .el-form-item__content,
.card-item.addForm ::v-deep .el-form-item .el-form-item__content #addFormButton {
  width: 100%;
}

.pdf-button {
  color: var(--blue500);
  font-size: var(--button-font-size);
  line-height: var(--button-line-height);
  font-weight: 700;
  cursor: pointer;
  display: block;
  margin-bottom: 8px;
}

.pdf-button i {
  font-size: 18px;
  margin-right: 4px;
}
</style>
